import { AfterViewInit, Component, ComponentFactoryResolver, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable, { CellHookData, ColumnInput, RowInput } from 'jspdf-autotable';
import { Utenteservice } from '../../../services/utente.service';
import { IAutoTablePDFConfig } from './IAutoTablePDFConfig';
import { confirm } from 'devextreme/ui/dialog';
import { EmailComponent } from '../../../widgets/email/email.component';
import { EventEmitter } from '@angular/core';
import { Router, UrlHandlingStrategy } from '@angular/router';
import { MontserratThin } from '../../../../assets/fonts/pdf-fonts/Montserrat-Thin-normal.js'; // '../assets/fonts/pdf-fonts/Montserrat-normal.js';
import { MontserratBold } from '../../../../assets/fonts/pdf-fonts/Montserrat-Bold-normal.js'
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { NicaFormComponent } from '../../nica-form/nica-form.component';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { ModelliStampaService } from '../../../services/modelli-stampa.service';
import { ComponentService } from '../../../services/component.service';



const fontSizeVariables = 6;


@Component({
  selector: 'anteprima-pdf',
  templateUrl: './anteprima-pdf.component.html',
  styleUrls: ['./anteprima-pdf.component.css']
})


export class AnteprimaPDfComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('containerDinamico', { static: false, read: ViewContainerRef }) containerDinamico: ViewContainerRef;
  @ViewChild('modificaAnteprimaForm', { static: false }) modificaAnteprimaForm: NewNicaFormComponent;

  @Input() jsonDaEsterno: string = "";
  //@Input() lookups : any[] = [];

  @Output() emettiChiusura = new EventEmitter<any>();
  json: IAutoTablePDFConfig;
  $date: string = "";
  $time: string = "";
  $totalPages: string = "";
  $userName: string = "";
  $nomeCompleto: string = "";
  $descr_licenza: string = "";
  @Input() $title: string = "";
  @Input() rimuoviButtonUscita: boolean = false;
  @Input() nascondiTastoAnchor?: boolean = false;
  @Input() height?: string;
  //@Input() file? : File | Blob;

  @Input() showToolbar: boolean = true;

  @Input() fileData?: Blob;
  @Input() fileURL?: string;

  @Input() tipoFile?: string; //mimeType
  @Input() isFile?: boolean = false;
  //headerData:Array<Array<string>>;
  colonne: ColumnInput[] = [];

  isCreatedThroughTemplate: boolean = true;
  src: string = "";
  caricamentoTerminato: boolean = false;
  mostraPopupModifica: boolean = false;
  mostraPopupInviaEmail: boolean = false;

  formatiDateTime = [
    moment.ISO_8601
  ];



  toolbarButtons = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salva',
      cssClass: 'salvaButtonExcelExporter',
      class: 'salvaButtonExcelExporter',
    },
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annulla',
      cssClass: 'escludiQuesto'
    },
  ];

  pulsantiToolbarAnteprima: any[] = [
    {
      id: 0,
      value: 0,
      text: 'Chiudi',
      icon: 'icon-exit',
      visible: true,
      displayMode: 'in-line',

    },
    {
      id: 1,
      value: 1,
      text: 'Modifica PDF',
      icon: 'icon-modifica-profilo',
      visible: true,
      displayMode: 'in-line',

    },
    /*
    {
      id:2,
      value:2,
      text:'Invia Email',
      icon:'icon-mail',
      visible:true,
      displayMode:'in-line',
    },
    */
  ];


  formDataModifica = {
    titolo: "",
    formato: "A4",
    orientamento: ""
  }

  pulsanteModificaFormOptions: any;
  pulsanteChisuraFormOptions: any;

  constructor(private utenteService: Utenteservice, private factory: ComponentFactoryResolver, private routerService: Router, private modelliStampaService: ModelliStampaService, private componentService : ComponentService) {

    let datiUtente = utenteService.InfoDatiUtenteConnesso;

    this.$userName = datiUtente.userName;

    this.$nomeCompleto = datiUtente.nomeCompleto;

    this.$descr_licenza = datiUtente.descr_licenza;

  }
  ngAfterViewInit(): void {

    //document.getElementById('toolbar').style.visibility='hidden';

    if (this.isFile && this.fileURL) {


      setTimeout(
        () => {
          //alert("pippo");
          this.apriAnteprimaDaFile();
          document.getElementById('toolbar').style.visibility = 'visible';
          document.getElementById('divLoader').style.display = 'none';
        }, 100
      );


    }

    /*
    if(!this.jsonDaEsterno || this.jsonDaEsterno !==''){
      document.getElementById('toolbar').style.visibility='hidden';
    
      setTimeout(
        ()=> {
          alert("pippo");
          this.mostraDati(this.jsonDaEsterno);
          document.getElementById('toolbar').style.visibility='visible';
          document.getElementById('divLoader').style.display='none';
          
          }
        ,500
        );

        
     } 
     return;
     */
  }
  ngOnDestroy(): void {

    if (window.document.getElementById("anteprimaPDF") !== null)
      window.document.getElementById("anteprimaPDF").remove();

    if (window.document.getElementById("frame") !== null)
      window.document.getElementById("frame").remove();

    if (window.document.getElementById("divLoader") !== null)
      window.document.getElementById("divLoader").remove();

    if (window.document.getElementById("toolbar") !== null)
      window.document.getElementById("toolbar").remove();

  }

  mostraDati(jsonDaEsterno: string) { //Da utilizzare per realizzare dinamicamente il componente, in alternativa alla nascita del componente da richiamo in HTML
    if (!jsonDaEsterno) return;


    this.json = (JSON.parse(jsonDaEsterno) as IAutoTablePDFConfig);
    if (this.json) {

      /*
      if(this.json.Rows.length>=10009999999)
        alert('Il massimo numero di righe stampabili è pari a 1000, le righe in eccesso saranno rimosse in fase di stampa','Attenzione');
      */
      let data: Date = new Date();

      this.$date = `${data.getDate() < 10 ? '0' + data.getDate() : data.getDate()}/${data.getMonth() + 1 < 10 ? '0' + (data.getMonth() + 1) : (data.getMonth() + 1)}/${data.getUTCFullYear()}`;
      this.$time = `${data.getHours() < 10 ? '0' + data.getHours() : data.getHours()}:${data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes()}:${data.getSeconds() < 10 ? '0' + data.getSeconds() : data.getSeconds()}`;
      this.$title = this.json.Page.title;

      //Inizializzo i valori del form di modifica
      this.formDataModifica.titolo = this.json.Page.title;
      this.formDataModifica.orientamento = this.json.Page.orientamento;
      this.formDataModifica.formato = this.json.Page.formato;

      this.colonne = this.modelliStampaService.getColumnInputArray(this.json);

      this.generaAnteprimaPDF();

    }
  }

  ngOnInit(): void {

    let t = this;
    // (document.getElementsByClassName("dx-menu-item-wrapper").item(document.getElementsByClassName("dx-menu-item-wrapper").length-1) as HTMLElement).style.position="fixed";
    // (document.getElementsByClassName("dx-menu-item-wrapper").item(document.getElementsByClassName("dx-menu-item-wrapper").length-1) as HTMLElement).style.right="5px";
    this.pulsanteModificaFormOptions = {
      text: 'Applica',
      type: 'normal',
      onClick: () => {
        t.onFormModificaSubmit(undefined);
      }
    }

    this.pulsanteChisuraFormOptions = {
      text: 'Annulla',
      type: 'normal',
      onClick: () => {
        t.chiudiPopupModifica(undefined);
      }
    }

    if (this.isCreatedThroughTemplate && this.jsonDaEsterno) {

      this.mostraDati(this.jsonDaEsterno);

    }


    if (typeof this.height == 'string' && this.height.length > 0)
      document.getElementById('frame').style.height = this.height;
  }


  inizializza() {

    let t = this;
    // (document.getElementsByClassName("dx-menu-item-wrapper").item(document.getElementsByClassName("dx-menu-item-wrapper").length-1) as HTMLElement).style.position="fixed";
    // (document.getElementsByClassName("dx-menu-item-wrapper").item(document.getElementsByClassName("dx-menu-item-wrapper").length-1) as HTMLElement).style.right="5px";
    this.pulsanteModificaFormOptions = {
      text: 'Applica',
      type: 'normal',
      onClick: () => {
        t.onFormModificaSubmit(undefined);
      }
    }

    this.pulsanteChisuraFormOptions = {
      text: 'Annulla',
      type: 'normal',
      onClick: () => {
        t.chiudiPopupModifica(undefined);
      }
    }

    if (this.isCreatedThroughTemplate && this.jsonDaEsterno) {



      this.mostraDati(this.jsonDaEsterno);


    }


    if (typeof this.height == 'string' && this.height.length > 0)
      document.getElementById('frame').style.height = this.height;
  }

  OttieniRighe() {
    const CaculateValue = function (field, row) {
      let result = "";
      let composite = field.field.split("+")
      if (composite.length == 0) result = row[field.field]
      else {
        composite.forEach(element => {
          result += row[element];
          if (field.separatore) result = result + field.separatore; else result = result + " "
        });
        if (field.separatore) result = result.substring(0, result.length - field.separatore.length);
      }


      return result;

    }

    let allRow = [];
    this.json.Rows.forEach(currentRow => {
      let progColumn = -1;
      let singleRow = {};
      this.json.Headers.forEach(colomun => {
        let valueField = CaculateValue(colomun, currentRow)
        progColumn++;
        singleRow[progColumn] = valueField;

      });
      singleRow['data'] = currentRow
      allRow.push(singleRow);
      singleRow = {};
    });

    return allRow;
  }




  testoConVariabiliInserite(text: string, numeroPagina: string): string {

    let ris = text;


    ris = text.replace(/[$]pageNumber/g, numeroPagina)
      .replace(/[$]totalPages/g, this.$totalPages)
      .replace(/[$]date/g, this.$date)
      .replace(/[$]time/g, this.$time)
      .replace(/[$]userName/g, this.$userName)
      .replace(/[$]nomeCompleto/g, this.$nomeCompleto)
      .replace(/[$]descr_licenza/g, this.$descr_licenza)
      .replace(/[$]title/g, this.$title)
      .replace(/[$]/g, '');
    /*
    if(typeof pdf.putTotalPages === 'function'){
 
      ris=ris.replace(/[$]totalPages/g,numeroPagineTotaliExp);
     
      
    }
    */
    //console.log(ris);


    return ris;
  }

  /** @deprecated */
  getJSONColumnsWidth(): any {

    let res = {};

    for (let i = 0; i < this.json.Headers.length; i++) {

      console.warn('prima', this.json.Headers[i].width);

      let width = parseInt(this.json.Headers[i].width as any);

      if (typeof this.json.Headers[i].width == 'undefined')
        res[i] = 'wrap';
      else
        res[i] = {
          cellWidth: isNaN(width) ? this.json.Headers[i].width :
            width <= 180 ? 'wrap' : (width / 10) + 100
        };

      console.warn('dopo', res[i]);
    }

    console.warn(res);

    return res;
  }


  generaAnteprimaPDF() {
    const htmlToText = (html) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    };

    //let dati=this.OttieniRighe();

    let body: RowInput[] = this.modelliStampaService.getRowInputArray(this.json);


    let orientamento: any = this.json.Page.orientamento;
    let formato: any = this.json.Page.formato;
    let originalTextColor;


    //Creo l'oggetto che rappresenta il pdf
    let pdf = new jsPDF({
      orientation: orientamento, //visualizzazione
      format: formato,
      unit: "px",
    });

    //Nuovo Font in uso: "Helvetica Neue","Segoe UI",helvetica,verdana,sans-serif;

    pdf.addFileToVFS("MontserratThin.ttf", MontserratThin);
    pdf.addFileToVFS("MontserratBold.ttf", MontserratBold);

    pdf.addFont("MontserratThin.ttf", "MontserratThin", undefined, "secco");

    pdf.addFont("MontserratThin.ttf", "MontserratThin", undefined, "snello");
    pdf.addFont("MontserratBold.ttf", "MontserratBold", undefined, "bold");
    //pdf.setFont("courier","bold");





    //aggiungo props al pdf come il titolo
    pdf.setProperties(
      {
        title: this.$title.concat(".pdf"),
        creator: "RentrinCloud",
        author: "RentrinCloud",
      }
    );

    //const larghezzaColonne = this.getJSONColumnsWidth();

    autoTable(pdf, {

      columns: this.colonne,
      body: body,
      headStyles: {
        font: 'MontserratBold',
        //fontStyle: 'bold',
        fillColor: 'd1e0ed',  //'023957',
        textColor: '023957', //'white',
        fontSize: 5,
        lineColor: 'd1e0ed',  //'023957',
        lineWidth: 0.2,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 4 },
        //cellWidth:'wrap'
      },
      bodyStyles: {
        font: 'Courier',//'MontserratBold',//'MontserratThin',
        textColor: '023957',
        fontSize: 6,
        lineWidth: 0.2,
        fontStyle: 'bold',
        cellPadding: { top: 0, right: 0, bottom: 0, left: 0 },
      },
      tableWidth: 'auto',

      //OPPURE
      //columnStyles: larghezzaColonne,
      /*{
        0:{cellWidth:80}
      },
      */

      //body:this.json.Rows,
      /*
              if(cella.cell.text[0].includes('!')){
              let singleElement=cella.cell.text[0].split("!")
              if(singleElement.length>0){
                let left=0;
                let newHtml='';          
                for(let r=0;r<singleElement.length;r++){
                  newHtml+=`<div style="margin-left:${left}px;">${singleElement[r]}</div>`;
                  left+=50;
                }
                cella.cell.text[0]=htmlToText(newHtml)
              }
            }
      
      */
      didDrawCell: function (data) {
        const cell = data.cell;
        const row = data.row;
        const column = data.column;
        const textArray = cell.raw;
        let rowYPosition = data.cell.y
        let masterLeft = 0;
        if (data.section == 'body') {


          if (data.cell.colSpan > 1) {
            const cellIndex = data.table.columns.findIndex(column => column.dataKey === data.column.dataKey);
            const nextCellIndex = cellIndex + 1;
            if (data.row.cells[nextCellIndex]) {
              delete data.row.cells[nextCellIndex]; // Rimuove la cella successiva
            }
          }


          if(!Array.isArray(data.row.raw)) return;
          (data.row.raw as any).forEach(element => {
            if (element.data && element.data.left) masterLeft = element.data.left
            if (element.data && element.data.settings) {
              if (element.data.settings.styleCell) {
                let celStyle = element.data.settings.styleCell
                if (celStyle.colSpan)
                  cell.colSpan = celStyle.colSpan;
              }
              // potrei leggere un config con lo style della cella o altro
              // ma non è gestito 
            }
          });


        }

        //const usablePageHeight = pageHeight - marginTop - marginBottom;
        //rowYPosition + estimatedRowHeight > usablePageHeight
        // console.log("didDrawCell ", data)
        // if (data.cell.raw == undefined) return;
        // let Text = data.cell.raw.toLocaleString()
        // const lineHeight = cell.styles.fontSize / pdf.internal.scaleFactor * 1.15;
        // let textY = cell.y + cell.padding('top') + 1;
        // if (Text.includes('§')) {
        //   rowYPosition += data.cell.contentHeight
        //   let cF = data.doc.getPageHeight();
        //   if (rowYPosition > cF - 100) {
        //     //data.doc.addPage();
        //     //data.cell.y=30;
        //   }
        //   let singleElement = Text.split("§")
        //   if (singleElement.length > 0) {
        //     let left = masterLeft;
        //     let newHtml = '';
        //     pdf.setTextColor('' + originalTextColor);
        //     for (let r = 0; r < singleElement.length; r++) {
        //       let x = cell.x + cell.padding('left') + left
        //       if (singleElement[r].includes('|')) {
        //         let singleElement2 = singleElement[r].split("|")
        //         for (let r2 = 0; r2 < singleElement2.length; r2++) {
        //           if (singleElement2[r2] > '') {
        //             pdf.text(singleElement2[r2], x, textY);
        //             textY += lineHeight;
        //           }
        //         }
        //         left += 15;
        //       } else
        //         if (singleElement[r] > '') {
        //           pdf.text(singleElement[r], x, textY);
        //           //newHtml+=`<div style="margin-left:${left}px;">${singleElement[r]}</div>`;
        //           left += 15;
        //           textY += lineHeight;
        //         }
        //     }
        //     data.cell.text = ['', '', '', ''];
        //   }
        // } else
        //   if (Text.includes("|")) {
        //     pdf.setTextColor('' + originalTextColor);
        //     let singleElement2 = Text.split("|")


        //     for (let r2 = 0; r2 < singleElement2.length; r2++) {
        //       if (singleElement2[r2] > '') {
        //         let x = cell.x + cell.padding('left')
        //         let cF = data.doc.getPageHeight();
        //         if (textY > cF - 100 && r2 == 0) {
        //           //data.doc.addPage();
        //           //data.cell.y=30;
        //           //textY=30;
        //         }
        //         pdf.text(singleElement2[r2].trim(), x, textY);
        //         textY += lineHeight;
        //       }
        //     }

        //   }


      },
      didDrawPage: (pagina) => {

        //Impostazioni e Aggiunte non appartenente alla tabella


        pdf.setFont("MontserratBold", undefined, "bold");
        pdf.setTextColor('023957');
        //console.log(pdf.getNumberOfPages()); // al primo giro è 1, al secondo è 2 ...

        let t = this; //Creo una copia dell'oggetto che mi servirà nella funzione nidificata seguente



        //Funzione Dentro al metodo





        //dimensioni massimali della pagina attuale
        var pageSize = pdf.internal.pageSize;
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        //pdf.addFont("Comic Sans MS-normal.ttf","Comic Sans MS","normal");


        //pdf.setFontSize(15);




      },


      didParseCell: (cella: CellHookData) => {

        //Per effettuare allinamenti di colonne
        //console.log(cella);
        for (let head of this.json.Headers) {
          if (head.field === cella.column.dataKey) {
            //if(head.field=='xt') head.width=1500
            switch (head.align.toLowerCase()) {

              case 'l':
              case 'left':
                {
                  cella.cell.styles.halign = "left";

                };
                break;
              case 'c':
              case 'center':
                {
                  cella.cell.styles.halign = "center";
                };
                break;
              case 'r':
              case 'right':
                {
                  cella.cell.styles.halign = "right";
                };
                break;
              default:
                {
                  cella.cell.styles.halign = "left";
                }
                break;




            }
          }
        }

        if (cella.section === "body") {
          cella.cell.styles.cellPadding = { left: 4, right: 4, top: 3 };
          if (cella.cell.raw == undefined) return;
          let q1 = cella.cell.raw.toLocaleString()
          //Totale
          if (q1.includes('Totale')) {
            cella.cell.styles.halign = 'right'

          }
        }

        switch (cella.cell.raw.toString().toLowerCase().trim()) {

          case 'true':
            {
              cella.cell.text = ['Si'];

            } break;

          case 'false': {
            cella.cell.text = ['No'];
          } break;

          case 'null':
          case 'undefined':
            {
              cella.cell.text = [''];
            } break;


        }



        /*
         if(moment((cella.cell.raw as any),this.formatiDateTime,true).isValid()){
  
  
          
          cella.cell.text = [cella.cell.raw.toString().split('T')[0]];
  
         }*/

        //Caso specifico
        if (cella.section === 'body') {


          let q1 = cella.cell.raw.toLocaleString()
          //Totale
          if (q1.includes('Totale')) {

          }
          let q = cella.cell.raw.toLocaleString();
          originalTextColor = cella.cell.styles.textColor;
          if (cella.column.dataKey === 'xt' || q.includes("|")) {
            originalTextColor = cella.cell.styles.textColor;
            cella.cell.styles.textColor = cella.cell.styles.fillColor;
            pdf.setTextColor('' + cella.cell.styles.fillColor);


            let q = cella.cell.raw.toLocaleString()
            let count = q.split('§').length - 1;
            count += q.split('|').length - 1;
            count += 1;
            const lineHeight = cella.cell.styles.fontSize / pdf.internal.scaleFactor * 1.15;
            console.log("Altezza Pagina ", cella.doc.getPageHeight());
            let newH = cella.cell.y + cella.cell.padding('top') + 5 + count * lineHeight
            // let cH=cella.doc.getPageHeight();
            //if(newH>cH)
            //console.log("Superato Pagina ",cella.doc.getPageHeight());
            // cella.cell.styles.cellWidth = 'wrap';
            //cella.cell.styles.overflow = 'linebreak';

            cella.cell.styles.minCellHeight = newH;//count*lineHeight;
            //cell.y + cell.padding('top')+5;
            /*let d=" ";
            for(let c=0;c<150;c++)
              d+=' ';
            cella.cell.text.push(d);
            cella.cell.text.push(d)
            */
            //cella.cell.text.push(d)
          }
          if (cella.column.dataKey === 'guidAccettazione') {

            console.log(cella.cell.text)

            if (cella.cell.text[0] !== '') {
              //cella.cell.text = ['<img width="32px" title="In attesa di accettazione" src="https://img.icons8.com/external-parzival-1997-flat-parzival-1997/64/000000/external-no-touch-touchless-society-parzival-1997-flat-parzival-1997-1.png"/>']

              //let posTesto = cella.cell.getTextPos();

              cella.cell.text = ['In Attesa'];

            } else {
              //cella.cell.text = ['<img width="32px" title="Accettata iscrizione" src="https://img.icons8.com/color/48/000000/checked--v1.png"/>'];

              cella.cell.text = ['Confermata'];
            }
          }

          if (cella.column.dataKey == 'tipoAttivita') {


            //console.warn(cella);

            let rigaAttuale = this.json.Rows[cella.row.index];

            let attivitaSvolte = '';

            if (rigaAttuale['isProduttore'] == true)
              attivitaSvolte += 'P ';

            if (rigaAttuale['isTrasportatore'] == true)
              attivitaSvolte += 'T ';

            if (rigaAttuale['isDestinatarioRifiuto'] == true)
              attivitaSvolte += 'D ';


            if (rigaAttuale['isIntermediario'] == true)
              attivitaSvolte += 'I ';

            attivitaSvolte = attivitaSvolte.trim().replace(/[ ]/g, '-');




            cella.cell.text = [`${attivitaSvolte}`];




          }

          /*
          if(this.lookups.length>0){
  
            for(let lookup of this.lookups){
  
              if(lookup['dataField']===cella.column.dataKey){
  
                const valueExpr : string = lookup.lookup.valueExpr;
                const displayExpr : string = lookup.lookup.displayExpr;
  
  
                for(let obj of lookup.lookup.dataSource){
  
  
  
                  if(obj[`${valueExpr}`].toString() === cella.cell.raw.toString().substring(0,cella.cell.raw.toString().length-1)){
  
                    cella.cell.text = [obj[`${displayExpr}`]];
                    
                  }
                 
                  
  
  
                }
              }
              
            
              }
              
            }*/


        }

      }



    }); //chiusura autotable

    /*
    if(typeof pdf.putTotalPages === 'function'){


      console.warn(numeroPagineTotaliExp);
      
      pdf.putTotalPages(numeroPagineTotaliExp);
      
    }
    */

    let pageCount: number = (pdf as any).internal.getNumberOfPages();
    this.$totalPages = pageCount.toString();

    if (this.json.HeaderPage) {


      for (let head of this.json.HeaderPage) {


        for (let i = 1; i <= pageCount; i++) {

          pdf.setPage(i);

          pdf.setFont("MontserratBold", undefined, "bold");

          pdf.setTextColor('023957');

          var pageSize = pdf.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();



          switch (head.align.toLowerCase()) {

            case 'l':
            case 'left': { //nel caso fosse a sinistra



              pdf.setFontSize(fontSizeVariables);



              //Se presente SOLO LA VARIABILE DEL TITOLO, ne aumento il fontSize
              if (this.testoConVariabiliInserite(head.text, i.toString()).toLowerCase() === this.json.Page.title.toLowerCase()) {

                pdf.setFontSize(fontSizeVariables);

              }


              //Qui vado a rimpiazzare le variabile contenute nel testo dell'head con i valori calcolati 

              //il page number SE PRESENTE O MENO va trattato in questo modo
              pdf.text(this.testoConVariabiliInserite(head.text, i.toString()), 30, 20);



            }
              break;
            case 'c':
            case 'center': { //nel caso fosse al centro



              pdf.setFontSize(fontSizeVariables);




              //Se presente SOLO LA VARIABILE DEL TITOLO, ne aumento il fontSize
              if (this.testoConVariabiliInserite(head.text, i.toString()).toLowerCase() === this.json.Page.title.toLowerCase()) {

                pdf.setFontSize(fontSizeVariables);


              }


              pdf.text(this.testoConVariabiliInserite(head.text, i.toString()), (pageWidth / 2) - (pdf.getTextWidth(this.testoConVariabiliInserite(head.text, i.toString())) / 2), 20)




            }
              break;
            case 'r':
            case 'right': { //nel caso fosse a destra




              pdf.setFontSize(fontSizeVariables);


              //Se presente SOLO LA VARIABILE DEL TITOLO, ne aumento il fontSize
              if (this.testoConVariabiliInserite(head.text, i.toString()).toLowerCase() === this.json.Page.title.toLowerCase()) {

                pdf.setFontSize(fontSizeVariables);


              }



              pdf.text(this.testoConVariabiliInserite(head.text, i.toString()), pageWidth - pdf.getTextWidth(this.testoConVariabiliInserite(head.text, i.toString())) - 30, 20);



            }

              break;
            default: {

              //se non specificato l'elemento verrà messo a sinistra

              pdf.setFontSize(fontSizeVariables);


              //Se presente SOLO LA VARIABILE DEL TITOLO, ne aumento il fontSize
              if (this.testoConVariabiliInserite(head.text, i.toString()).toLowerCase() === this.json.Page.title.toLowerCase()) {

                pdf.setFontSize(fontSizeVariables);


              }


              pdf.text(this.testoConVariabiliInserite(head.text, i.toString()), 30, 20);

            }

              break;

          }


        }

      }
    }


    //COSTRUZIONE FOOTER
    if (this.json.FooterPage) {




      for (let foot of this.json.FooterPage) {

        for (let i = 1; i <= pageCount; i++) {

          pdf.setPage(i);

          pdf.setFont("MontserratBold", undefined, "bold");
          pdf.setTextColor('023957');

          var pageSize = pdf.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

          switch (foot.align.toLowerCase()) {

            case 'l':
            case 'left': { //nel caso fosse a sinistra



              pdf.setFontSize(fontSizeVariables);


              //Se presente SOLO LA VARIABILE DEL TITOLO, ne aumento il fontSize


              //Qui vado a rimpiazzare le variabile contenute nel testo dell'head con i valori calcolati 

              //il page number SE PRESENTE O MENO va trattato in questo modo
              pdf.text(this.testoConVariabiliInserite(foot.text, i.toString()), 30, pageHeight - 20);



            }
              break;
            case 'c':
            case 'center': { //nel caso fosse al centro



              pdf.setFontSize(fontSizeVariables);





              pdf.text(this.testoConVariabiliInserite(foot.text, i.toString()), (pageWidth / 2) - (pdf.getTextWidth(this.testoConVariabiliInserite(foot.text, i.toString())) / 2), pageHeight - 20)




            }
              break;
            case 'r':
            case 'right': { //nel caso fosse a destra




              pdf.setFontSize(fontSizeVariables);





              pdf.text(this.testoConVariabiliInserite(foot.text, i.toString()), pageWidth - pdf.getTextWidth(this.testoConVariabiliInserite(foot.text, i.toString())) - 30, pageHeight - 20);







            }

              break;
            default: {

              //se non specificato l'elemento verrà messo a sinistra

              pdf.setFontSize(fontSizeVariables);






              pdf.text(this.testoConVariabiliInserite(foot.text, i.toString()), 30, pageHeight - 20);

            }

              break;

          }

        }


      }


    }














    let base64DataUri = pdf.output('datauristring', { filename: this.json.Page.title });



    let uint = this.convertiDataURIToBinary(base64DataUri);

    let blob = new Blob([uint], { type: 'application/pdf' });

    //console.error("Eccoci");

    this.fileData = new File([blob], this.json.Page.title.concat('.pdf'), { type: 'application/pdf' });


    //let embedString : string= `<embed id='embedPDF' style='width:100%;height:100%' src=/>`;

    let embedElement: HTMLEmbedElement = window.document.createElement('embed');


    let fileURL = URL.createObjectURL(this.fileData);




    embedElement.setAttribute('id', 'anteprimaPDF'); //assegno un id all'embed serve poi per la rimozione specifica


    let exit = {
      name: 'endAnteprima'
    }
    this.emettiChiusura.emit(exit);
    /*
    var obj = document.createElement('iframe');
    obj.style.width = '100%';
    obj.style.height = '842pt';
    obj.src=base64DataUri;
    document.getElementById('frame').appendChild(obj); 
    */


    //il file rappresentato in formato base64, ha un problema ossia che se il file è molto grande, il contenuto del file stesso verrà ridotto, per questo motivo usiamo l'url

    embedElement.src = fileURL;//.concat("#toolbar=0"); per disattivare           //passo all'attributo src il pdf letto come datauristring


    embedElement.type = "application/pdf";

    //occupo il 100% delle dimensioni del div in cui risiedo


    embedElement.style.width = '100%';

    embedElement.style.height = this.height ? this.height : '98%'; //97% per prendere anche la scrollbar inferiore quando si zooma sul pdf

    this.caricamentoTerminato = true;

    if (this.caricamentoTerminato) {
      //console.log("PIPPO");
      window.document.getElementById("toolbar").style.visibility = "visible";
      document.getElementById("divLoader").style.display = "none";
    }

    //console.log(window.navigator.userAgent);

    this.sostituisciPulsanteDownload(fileURL);

    const frame = window.document.getElementById("frame")
    frame!.appendChild(embedElement); //appendo il nuovo elemento creato sotto la toolbar




    //frame.style.height = (typeof this.height == 'string' && this.height.length > 0) ? this.height : '100%';

  }

  //Questo metodo ha il compito di sostituire il pulsante del pdf viewer con uno personalizzato
  sostituisciPulsanteDownload(urlFile: string) {

    if (this.nascondiTastoAnchor == true)
      return;

    /*
    let containerAnchor : HTMLDivElement = document.createElement("div");

    containerAnchor.style.width="100%";
    containerAnchor.style.height="7.5%";
    containerAnchor.style.backgroundColor="white";
    containerAnchor.style.border="1px solid blue";
    containerAnchor.style.position="absolute";

    window.document.getElementById("frame")!.appendChild(containerAnchor);
    */

    let testAnchor: HTMLAnchorElement = document.createElement("a");



    testAnchor.id = "testAnchor";
    //testAnchor.download = this.$title.concat('.pdf');

    //testAnchor.href=urlFile;

    testAnchor.onclick = () => {
      saveAs(new Blob([this.fileData], { type: 'application/pdf' }), `${this.$title}.pdf`);
    }


    testAnchor.style.width = !window.navigator.userAgent.includes("Edg") ? "41px" : "42px";
    testAnchor.style.height = !window.navigator.userAgent.includes("Edg") ? "41px" : "42px";
    testAnchor.style.position = "absolute";


    //testAnchor.style.borderRadius="100%";
    testAnchor.title = "Scarica";

    let cerchioHover = document.createElement("div");
    cerchioHover.style.borderRadius = !window.navigator.userAgent.includes("Edg") ? "50%" : "";
    cerchioHover.style.width = !window.navigator.userAgent.includes("Edg") ? "90%" : "100%";
    cerchioHover.style.height = !window.navigator.userAgent.includes("Edg") ? "90%" : "100%";

    testAnchor.appendChild(cerchioHover);


    testAnchor.onmouseover = (evt) => {
      //cerchioHover.style.zIndex="2000";
      cerchioHover.style.backgroundColor = !window.navigator.userAgent.includes("Edg") ? "#f1f5fa1f" : "rgb(1 2 3 / 4%)";
    }

    testAnchor.onmouseleave = (evt) => {
      //cerchioHover.style.zIndex="-1";
      cerchioHover.style.backgroundColor = "";
    }



    //Nel caso in cui la pagina sia visualizzata attraverso Google Chrome  
    if ((window as any).chrome !== undefined && !window.navigator.userAgent.includes("Edg") && (window.devicePixelRatio * 100) == 100) {

      testAnchor.style.right = "82px";
      testAnchor.style.top = "10px";

      window.document.getElementById("frame")!.appendChild(testAnchor);
    }//oppure attraverso Edge
    else if ((window as any).chrome !== undefined && window.navigator.userAgent.includes("Edg") && (window.devicePixelRatio * 100) == 100) {

      testAnchor.style.right = "69px";
      testAnchor.style.top = "5px";
      testAnchor.style.width = "40px";
      testAnchor.style.height = "30px";

      window.document.getElementById("frame")!.appendChild(testAnchor);


    }

    //Se non zoommo la pagina allora potrò sostituire il pulsante
    window.addEventListener('resize', () => {
      const browserZoomLevel = Math.round(window.devicePixelRatio * 100);


      if (browserZoomLevel !== 100) {
        window.document.getElementById("frame")!.removeChild(testAnchor);
      }
      else {
        window.document.getElementById("frame")!.appendChild(testAnchor);
      }

    });



  }







  //Questo metodo ci permetterà di ricevere il valore dall'emit del componente app-toolbar e in base all'indice(quindi al tasto modificare i valori)
  appToolBarEvent(e) {
    //alert(e,"ww");
    switch (e) {
      case 0: {

        this.emettiChiusuraDiQuestoComponente();

      }
        break;
      case 1: {
        const data = {
          service: 'modificaAnteprimaPDF',
          api: 'modificaAnteprimaPDF',
          toolbarTop:false,
          toolbarBottom:true,
          disableEditForm:false,
          isEdit:false,
          heightForm:232,
          type: "simple",
          remoteOperation: false,
          dataJson: {
            titolo: this.formDataModifica.titolo,
            orientamento:this.formDataModifica.orientamento
          },
          CustomButtonSetForm: [
            {
              location: 'after',
              stylingMode: 'text',
              widget: 'dxButton',
              locateInMenu: 'never',
              text: 'Salva',
              icon: 'glyphicon mdi mdi-content-save-outline',
              event: 'conferma',
            },
            {
              location: 'after',
              stylingMode: 'text',
              widget: 'dxButton',
              locateInMenu: 'never',
              text: 'Annulla',
              icon: 'glyphicon glyphicon icon-annulla-form',
              event: 'annulla',
            },
          ],
          standardBtnBottom: []
        }

        let newGuid = Math.random().toString().replace("0.", "")

        this.componentService.setNewPopUp(newGuid, 'NewNicaFormComponent', null, '500', null, data, false, true, 'Modifica PDF', 'top')

        this.componentService.outputComponent.subscribe((res) => {

          if (res.name === 'return' || res.name == 'annulla' && res.guid == newGuid) {
            return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
          }
          
          if (res.name === 'conferma' && res.guid == newGuid ){

            this.formDataModifica.orientamento = data.dataJson.orientamento;
            this.formDataModifica.titolo = data.dataJson.titolo;

            this.onFormModificaSubmit(undefined);

            return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
          }

        });

      }
        break;
      case 2: {

       
    }
    break;
  }
}

  /*
   showPopupModifica(){

    let guid = Math.random().toString().replace("0.", "")
    let instanceData ={
     
      service: 'modificaAnteprimaPDF',
      api: '',
      filterKey: '',
      queryString: '',
      dataJson: null,
      type: 'simple',
      nCol: 1,
      remoteOperation: false,
      toolbarTop: false,
      toolbarBottom: true,
      heightForm: 333,
      ngClass: 'modifica-pdf',

    }
    this.componentService.setNewPopUp(guid, 'NewNicaFormComponent', null, null, null,instanceData, false, true, '');
    this.componentService.outputComponent.subscribe(res => {
     

      if (res.name == 'return' && res.guid == guid) {
        this.componentService.destroyCurrentOpenPopUpByGuid(guid)

        return;

      }

      if (res.name == 'submitFormStatic' && res.guid == guid) {

        const formData = res.data
       
        this.formDataModifica.titolo = formData['titolo'];
        this.formDataModifica.formato = formData['formato'];
        this.formDataModifica.orientamento = formData['orientamento'];


        this.onFormModificaSubmit(undefined);
       
        
      }



    })

  }
  
  */

  cambiaOrientamento(evt) {
    this.formDataModifica.orientamento = evt.value;
  }

  onFormModificaSubmit(evt) {

    this.json.Page.orientamento = (this.formDataModifica.orientamento as any);
    this.json.Page.formato = this.formDataModifica.formato;
    this.json.Page.title = this.formDataModifica.titolo;
    this.$title = this.formDataModifica.titolo;


    //window.document.getElementsByTagName("embed").item(0).remove();

    if (window.document.getElementById('anteprimaPDF') !== null)
      window.document.getElementById('anteprimaPDF').remove(); //rimuovo l'elemento a quell'id generato internamente al codice

    this.mostraPopupModifica = false; //nascondo il popup

    document.getElementById('divLoader').style.display = 'block';
    document.getElementById('toolbar').style.visibility = 'hidden';
    setTimeout(() => {
      this.generaAnteprimaPDF();
      document.getElementById('toolbar').style.visibility = 'visible';
      document.getElementById('divLoader').style.display = 'none';
    }, 100)

    if (evt)
      evt.preventDefault();
  }

  convertiDataURIToBinary(dataURI): Uint8Array {

    let BASE64_MARKER = ';base64,';


    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }



  apriEmailComponent() {

    const factory = this.factory.resolveComponentFactory(EmailComponent);

    setTimeout(() => {

      this.containerDinamico.clear();

      let istanziatore = this.containerDinamico.createComponent(factory, 0);

      let grandezzaFileMB = Number.parseFloat((this.fileData.size / (1024 * 1024)).toFixed(2)); //da bytes a MB

      istanziatore.instance.outputEvent.subscribe(
        (evt) => {

          if (evt == 'chiudi')
            this.chiudiPopupInviaEmail(undefined);
        }
      )

      if (grandezzaFileMB <= 10)
        istanziatore.instance.files = this.fileData;
      else {
        //fare un confirm che se troppo grande "confermi di voler inoltrare lo stesso l'email"

        let conferma = confirm(`File in allegato di dimensioni superiori a 10MB, inoltrare lo stesso l'email ?`, 'Attenzione');

        conferma.then(
          (risposta) => {

            if (!risposta) {
              this.containerDinamico.clear();
              this.mostraPopupInviaEmail = false;
            }
            else
              return;
          }
        )
      }



    }, 500);


  }

  //Quando chiudi il form di modifica vado a resettare il form con i valori già presenti nel json
  chiudiPopupModifica(evt) {


    //this.containerDinamico.clear(); lo chiudo solo per sicurezza ma è inutile
    this.mostraPopupModifica = false;
    this.formDataModifica.orientamento = this.json.Page.orientamento;
    this.formDataModifica.formato = this.json.Page.formato;
    this.formDataModifica.titolo = this.json.Page.title;

  }

  chiudiPopupInviaEmail(ev) {

    this.containerDinamico.clear();
    this.mostraPopupInviaEmail = false;


  }

  emettiChiusuraDiQuestoComponente() {

    let exit = {
      name: 'close'
    }
    this.emettiChiusura.emit(exit);

  }


  //Con questo metodo, se volessi mostrare un pdf manderei il fileData(BLOB) oppure se un immagine, direttamente il link alla risorsa
  apriAnteprimaDaFile() {

    if (this.pulsantiToolbarAnteprima.length > 0 && this.pulsantiToolbarAnteprima[1])
      this.pulsantiToolbarAnteprima[1].visible = false;


    if (this.fileData) {

      this.fileData = new File([this.fileData], this.$title, { type: (this.tipoFile && this.tipoFile.length > 0) ? this.tipoFile : 'application/pdf' }); //application/pdf


      this.src = URL.createObjectURL(this.fileData);

    }
    else {

      this.src = this.fileURL;

      //console.warn(this.src);

    }



    //console.log(this.file,this.$title);




    let embedElement: HTMLEmbedElement = window.document.createElement('embed');

    embedElement.setAttribute('id', 'anteprimaPDF'); //assegno un id all'embed serve poi per la rimozione specifica

    embedElement.src = this.src; //passo all'attributo src il pdf letto come datauristring

    //occupo il 100% delle dimensioni del div in cui risiedo

    embedElement.style.width = '100%';

    embedElement.style.height = this.height ? this.height : '98%'; //97% per prendere anche la scrollbar inferiore quando si zooma sul pdf //97% per prendere anche la scrollbar inferiore quando si zooma sul pdf //97% per prendere anche la scrollbar inferiore quando si zooma sul pdf
    //embedElement.style.minHeight='700px';

    this.caricamentoTerminato = true;

    if (this.caricamentoTerminato && window.document.getElementById('divLoader') !== null && window.document.getElementById('toolbar') !== null) {

      window.document.getElementById('divLoader').style.display = 'none';
      document.getElementById('toolbar').style.visibility = 'visible';
    }

    this.sostituisciPulsanteDownload(embedElement.src);

    window.document.getElementById("frame")!.appendChild(embedElement); //appendo il nuovo elemento creato sotto la toolbar


  }

  htmlToPDF(testo: string) {



    if (testo.length == 0)
      return;

    //let htmlContainer: HTMLElement = document.createElement("div");

    //htmlContainer.innerHTML=testo;
    const t = this;

    let pdf = new jsPDF('p', 'pt', 'a4');


    let testoContainer: HTMLElement = document.createElement("div");

    testoContainer.style.width = "590px" //2.480px è la larghezza di un foglio A4 in formato cartaceo , 595 è sempre la larghezza di un foglio A4 ma in formato digitale 

    //testoContainer.style.border="3px solid red"
    //testoContainer.style.textAlign="center";
    testoContainer.style.padding = "5px";
    //console.log(testo);

    testoContainer.innerHTML = testo;

    pdf.html(testoContainer, {
      callback(doc) {
        //doc.save("test.pdf");





        let base64: any = doc.output("datauristring");

        let uint8Array = t.convertiDataURIToBinary(base64);

        t.fileData = new Blob([uint8Array], { type: "application/pdf" });

        t.apriAnteprimaDaFile();


      },
    });

    //this.file = new File([this.fileData],"Test",{type:"application/pdf"});

    //let tempUrl = URL.createObjectURL(this.file);

    //this.apriAnteprimaDaFile();

  }

  //È possibile mandare email anche spostandosi sulla toolbar dell'header della pagina
  //il problema è che se sono presenti 2 istanze dell'email component non sarà possibile 
  //inviare un email, in quanto scatterà la validazione di uno dei 2 componenti mail a prescindere
  //dopo la submit. Quindi mi sposto in una sezione della pagina in cui il componente indesiderato "morirà"
  onAperturaMailPopup(evt) {

    evt.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    evt.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    evt.component.content().classList.add("soggetto-form"); //add class to content


  }

  onAperturaPopupModifica(evt) {

    //this.showEdit = true;
    evt.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    evt.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    evt.component.content().classList.add("soggetto-form"); //add class to content

    evt.component.content().parentNode.parentNode.classList.add("popupOverlayHeightFixed");

    setTimeout(
      () => {



        if (!this.modificaAnteprimaForm.dataSet['titolo'])
          this.modificaAnteprimaForm.formRefreshInputData('titolo', this.formDataModifica.titolo);



        if (!this.modificaAnteprimaForm.dataSet['orientamento'])
          this.modificaAnteprimaForm.formRefreshInputData('orientamento', 'l')
        //onRadioGroupValueChanged({value:this.formDataModifica.orientamento},'orientamento');



      }, 500
    )
  }


  onAllEventModificaAnteprima(ev) {

    if (!ev || !ev.name)
      return;



    switch (ev.name) {
      case 'salva': {

        /*
        if(!this.modificaAnteprimaForm.formEdit.instance.validate().isValid)
            return;
        */

        this.formDataModifica.titolo = this.modificaAnteprimaForm.dataSet['titolo'];
        this.formDataModifica.formato = this.modificaAnteprimaForm.dataSet['formato'];
        this.formDataModifica.orientamento = this.modificaAnteprimaForm.dataSet['orientamento'];


        this.onFormModificaSubmit(undefined);


      } break;


      case 'annulla': {


        this.chiudiPopupModifica(undefined);


      } break;
    }
  }
}
